import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useFieldsCommentsApi Hook
 *
 * Pure API hook for field-level comment operations (fields_comments domain).
 * All calls target /api/fields-comments endpoints.
 *
 * @returns {{ addComment: Function, updateComment: Function, deleteComment: Function }}
 */
const useFieldsCommentsApi = () => {
  const addComment = useCallback(
    async ({
      comment,
      subFormId,
      fieldId,
      formId,
      endUserFilledFormId,
      attachedFiles,
      requestId,
    }) => {
      const response = await axiosInstance.post('/api/fields-comments/', {
        subFormId,
        fieldId,
        formId,
        comment,
        end_user_filled_form_id: endUserFilledFormId,
        attachedFiles,
        requestId,
      });
      return response.data;
    },
    []
  );

  const updateComment = useCallback(
    async ({
      id,
      comment,
      attachedFilesToAdd,
      attachedFilesToRemove,
      requestId,
    }) => {
      const response = await axiosInstance.put(`/api/fields-comments/${id}`, {
        comment,
        attachedFilesToAdd,
        attachedFilesToRemove,
        requestId,
      });
      return response.data;
    },
    []
  );

  const deleteComment = useCallback(async ({ id, requestId }) => {
    const response = await axiosInstance.delete(`/api/fields-comments/${id}`, {
      data: { requestId },
    });
    return response.data;
  }, []);

  return { addComment, updateComment, deleteComment };
};

export default useFieldsCommentsApi;
